import { FormControlLabel } from "@material-ui/core";
import styled from "styled-components";

export const CustomSwitchContainer = styled(FormControlLabel)`
  color: #6c7585 !important;
  margin: 0!important;
`;
